<refx-app-layout [dir] [@.disabled]="animationsDisabled$ | async">
  @if (!(appConfigService.isAppEmbedded$ | async)) {
    <refx-app-header-cont appHeader></refx-app-header-cont>
  }
  <ng-container mainContent>
    @if (!firstRouteActivated  && displaySkeletalLoader) {
      <refx-app-skeleton-pres></refx-app-skeleton-pres>
    }
    <router-outlet (activate)="onRouteActivated()"></router-outlet>
  </ng-container>
  @if (!(appConfigService.isAppEmbedded$ | async) && !(isCapacitorContext | async)) {
    <refx-app-footer appFooter></refx-app-footer>
  }
  <refx-debug-link-pres debugContent></refx-debug-link-pres>
</refx-app-layout>
<refx-gif-spinner id="spinner" [loading]="isPending$ | async" [loadingComplete$]="loadingComplete$"></refx-gif-spinner>
<refx-lazy-outlet [loadComponent]="displayDebugPanel" [isActive]="showDebugPanel"></refx-lazy-outlet>
